
    /**
     * @Author: sunchao
     * @Date:   2019/5/27 15:41
     */
    import { Component, Vue } from "vue-property-decorator";
    import Step from "@/components/Step.vue";
    import { getlable, silenceAuth } from "@/api";
    import config from "../../public/js/config";

    @Component({
        components: {
            Step
        }
    })
    export default class RealAuthentication extends Vue {
        private active: number      = 2;
        private labelList: number[] = [];
        private loading: boolean    = false;
        private enable: boolean     = false;
        private makenew: boolean    = true;

        private created() {
            // this.getLabel();
        }

        /**
         * 获取唇语文本
         * @param sessionId 当前会话的sessionId
         */
        private getLabel(): void {
            getlable()
                .then((resp: any) => {
                    if (resp.succ) {
                        this.enable    = false;
                        this.labelList = resp.data.label.split("");
                    } else if (resp.status === 20051) {
                        this.$dialog.alert({
                            message: "用户正在认证中,请稍后再试!"
                        })
                            .then(() => {
                                window.location.href = config.wechatBase + "#/userCenter";
                            });
                    } else if (resp.status === 20053) {
                        this.$dialog.alert({
                            message: "读数验证码过期，重新加载..."
                        })
                            .then(() => {
                                this.$router.push({ path: `/real-authentication` });
                            });
                    } else if (resp.status === 20060) {
                        this.$dialog.alert({
                            message: "用户信息过期，请重新确认认证信息!"
                        })
                            .then(() => {
                                this.$router.push({ path: `/info` });
                            });
                    } else {
                        this.$dialog.alert({
                            message: "认证信息加载失败，请重新认证!"
                        })
                            .then(() => {
                                window.location.href = config.wechatBase + "#/userCenter";
                            });
                    }

                });
        }

        private makopenclick() {
            this.makenew = true;
        }

        private makclick() {
            this.makenew = false;
        }

        /**
         * 打开手机原生摄像头进行录像
         */
        private watchCameraFile(e: any): void {
            const file: File   = e.target.files[0];
            const size: number = file.size / 1024 / 1024;
            // 大于20M时不能上传
            if (size > 20) {
                this.$dialog.alert({
                    message: "视频文件过大，请重新拍摄。"
                });
                return;
            }
            const formData = new FormData();
            formData.append("file", file);
            const operateType = window.sessionStorage.getItem("operateType")
            if (operateType === 'getRandom'){
                formData.append("saveFaceImg","1")
            }
            this.loading = true;
            this.uploadVideo(formData);
        }

        /**
         * 上传视频和校验
         * @param formData
         */
        private uploadVideo(formData: FormData) {
            const headerConfig: any = {
                "Content-Type": "multipart/form-data"
            };

            silenceAuth(formData, headerConfig)
                .then((resp: any) => {
                    this.loading   = false;
                    const { succ } = resp;
                    if (succ) {
                        this.$dialog.alert({
                            message: "认证成功！"
                        })
                            .then(() => {
                                const redirect = window.sessionStorage.getItem("redirect");
                                const operateType = window.sessionStorage.getItem("operateType")
                                if (redirect == "undefined" || redirect == undefined || redirect == "null") {
                                    window.location.href = config.wechatBase + "#/userCenter";
                                } else {
                                    let url = config.wechatBase + '#' + redirect
                                    if (operateType === 'getRandom'){
                                        url = url + "?operateType=" + operateType;
                                    }
                                    window.location.href = url;
                                }
                            });
                    } else {
                        if (resp.status == 10059) {
                            this.$dialog.alert({
                                message: "认证出错，请稍后再试！"
                            })
                                .then(() => {
                                    window.location.href = config.wechatBase + "#/userCenter";
                                });
                        } else if (resp.status == 20051) {
                            this.$dialog.alert({
                                message: "当前用户正在认证中..."
                            })
                                .then(() => {
                                    window.location.href = config.wechatBase + "#/userCenter";
                                });
                        } else if (resp.status == 10056 || resp.status == 10054) {
                            this.$dialog.alert({
                                message: "人脸识别未通过!"
                            })
                                .then(() => {
                                    window.location.href = config.wechatBase + "#/userCenter";
                                });
                        } else if (resp.status == 10055 || resp.status == 10057) {
                            this.$dialog.alert({
                                message: "实人认证未通过!"
                            })
                                .then(() => {
                                    window.location.href = config.wechatBase + "#/userCenter";
                                });
                        } else {
                            this.$dialog.alert({
                                message: "认证失败，请重新认证！"
                            })
                                .then(() => {
                                    window.location.href = config.wechatBase + "#/userCenter";
                                });
                        }
                    }
                })
                .catch(() => {
                    this.$dialog.alert({
                        message: "认证出错，请稍后再试！"
                    })
                        .then(() => {
                            window.location.href = config.wechatBase + "#/userCenter";
                        });
                });
        }
    }
